<template>
  <div id="adminContainer">
    <div class="inner">
      <div
        style="
          width: 6px;
          height: 20px;
          background: #464775;
          float: left;
          margin-right: 10px;
        "
      ></div>
      <div style="float: left; position: relative; top: -4px">
        <h3 class="pr-3" style="font-weight: 600" @click="updateOrganization()">
          영상장비관리
        </h3>
      </div>
      <div
        style="
          clear: both;
          width: 99%;
          height: 2.5px;
          background-color: #e9e9e9;
        "
      ></div>
      <!-- 영상장비등록 POPUP -->
      <modal name="addVideoDevice" :width="600" :height="750">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="top: 13%; width: 500px; padding: 0">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">
                영상장비 {{ deviceEditMode ? '수정' : '등록'
                }}<span class="titline"></span>
              </h1>
              <a @click="closeAddVideoDevicePopup()" class="pop_close">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <!--selectbox -->
                <select
                  class="formbox-select"
                  style="
                    font-size: 12pt;
                    padding-left: 10px;
                    width: 100%;
                    height: 40px;
                    margin-bottom: 15px;
                  "
                  v-model="editItem.companyId"
                  @change="companyChange"
                >
                  <option
                    v-for="companyData in companyList"
                    :key="companyData.value"
                    :value="companyData.value"
                  >
                    {{ companyData.text }}
                  </option>
                </select>
                <!--//selectbox -->

                <!--selectbox -->
                <select
                  class="formbox-select"
                  style="
                    font-size: 12pt;
                    padding-left: 10px;
                    width: 100%;
                    height: 40px;
                    margin-bottom: 15px;
                  "
                  v-model="editItem.buildingId"
                  @change="buildingChange"
                >
                  <option
                    v-for="buildingData in filterBuildingList"
                    :disabled="!buildingData.value ? true : false"
                    :key="buildingData.value"
                    :value="buildingData.value"
                  >
                    {{ buildingData.text }}
                  </option>
                </select>
                <!--//selectbox -->
                <select
                  class="formbox-select"
                  style="
                    font-size: 12pt;
                    padding-left: 10px;
                    width: 100%;
                    height: 40px;
                    margin-bottom: 15px;
                  "
                  v-model="editItem.roomId"
                >
                  <option
                    v-for="roomData in filterRoomList"
                    :disabled="!roomData.value ? true : false"
                    :key="roomData.value"
                    :value="roomData.value"
                  >
                    {{ roomData.text }}
                  </option>
                </select>
                <!--//selectbox -->

                <!--selectbox -->
                <!-- <div class="selectbox">
                  <label for="select">회사</label>
                  <select id="select">
                    <option selected>회사</option>
                    <option>회사</option>
                    <option>회사</option>
                    <option>회사</option>
                  </select>
                </div> -->
                <!--//selectbox -->

                <!--selectbox -->
                <!-- <div class="selectbox">
                  <label for="select">건물</label>
                  <select id="select">
                    <option selected>건물</option>
                    <option>건물</option>
                    <option>건물</option>
                    <option>건물</option>
                  </select>
                </div> -->
                <!--//selectbox -->

                <!--selectbox -->
                <!-- <div class="selectbox">
                  <label for="select">회의실</label>
                  <select id="select">
                    <option selected>회의실</option>
                    <option>회의실</option>
                    <option>회의실</option>
                    <option>회의실</option>
                  </select>
                </div> -->
                <!--//selectbox -->
                <span class="input_txt ico09"
                  ><input
                    type="text"
                    id=""
                    name=""
                    placeholder="단말IP"
                    v-model="editItem.ip"
                /></span>
                <span class="input_txt ico06"
                  ><input
                    type="text"
                    id=""
                    name=""
                    placeholder="Display명"
                    v-model="editItem.deviceName"
                /></span>
                <span class="input_txt ico06"
                  ><input
                    type="text"
                    id=""
                    name=""
                    placeholder="RemoteParty명"
                    v-model="editItem.uri"
                /></span>
                <span class="input_txt ico10"
                  ><input
                    type="text"
                    id=""
                    name="deviceId"
                    placeholder="단말ID"
                    autocomplete="off"
                    v-model="editItem.deviceId"
                /></span>
                <span class="input_txt ico11"
                  ><input
                    type="password"
                    id=""
                    name="password"
                    placeholder="단말PW"
                    autocomplete="new-password"
                    v-model="editItem.devicePw"
                /></span>

                <span class="input_txt ico05"
                  ><input
                    type="text"
                    id=""
                    name=""
                    placeholder="시리얼넘버"
                    v-model="editItem.sn"
                /></span>

                <span class="input_txt ico05"
                  ><input
                    type="text"
                    id=""
                    name=""
                    placeholder="코덱 시리얼넘버"
                    v-model="editItem.codecSn"
                /></span>
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a
                  class="btn_com small"
                  style="width: 100px"
                  @click="addVideoDevice()"
                  >{{ deviceEditMode ? '수정' : '등록' }}</a
                >
                <a
                  class="btn_line small"
                  style="width: 100px"
                  @click="closeAddVideoDevicePopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!-- 화장장비 삭제 POPUP -->
      <modal name="deleteVideoDevice" :width="550" :height="250">
        <div class="layer_popWrap" style="display: inline-block">
          <div class="bg"></div>
          <div class="inner" style="width: 500px; padding: 0">
            <!-- popHeader -->
            <div class="popHeader">
              <h1 class="pop_tit">
                영상회의 장비 삭제<span class="titline"></span>
              </h1>
              <a class="pop_close" @click="closeDeleteVideoDevicePopup()">x</a>
            </div>

            <!-- popContainer -->
            <div class="popContainer" style="min-height: 100px">
              <div class="pop_tbw">
                <p class="txt">선택하신 영상회의 장비를 삭제 하시겠습니까?</p>
              </div>

              <div class="btn_crud" style="margin-top: 30px">
                <a class="btn_com small" @click="deleteVideoDevice()">삭제</a>
                <a class="btn_line small" @click="closeDeleteVideoDevicePopup()"
                  >취소</a
                >
              </div>
            </div>
            <!-- //popContainer -->
          </div>
          <!-- //inner -->
        </div>
      </modal>

      <!--tbw-->
      <div class="tbw">
        <!--tbw_Top-->
        <div
          class="tbw_Top"
          style="
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <p
            class="title"
            style="
              width: 200px;
              margin-left: 16px;
              color: black;
              margin-bottom: 10px;
            "
          >
            <b style="font-size: 10pt">영상장비 목록</b>
          </p>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: end;
              width: 50%;
            "
          >
            <span class="input_filter_txt">
              <select
                class="formbox-select"
                style="
                  font-size: 12pt;
                  padding-left: 10px;
                  width: 100%;
                  height: 40px;
                  margin-bottom: 15px;
                "
                v-model="filter.buildingId"
              >
                <!-- Check -->
                <option
                  v-for="buildingData in buildingList"
                  :key="buildingData.value"
                  :value="buildingData.value"
                >
                  {{ buildingData.text }}
                </option>
              </select>
            </span>
            <span class="input_filter_txt"
              ><input
                type="text"
                placeholder="영상장비명"
                v-model="filter.deviceName"
                @keyup.enter="searchDevice()"
            /></span>
            <span class="input_filter_txt"
              ><input
                type="text"
                placeholder="단말 IP"
                v-model="filter.deviceIp"
                @keyup.enter="searchDevice()"
            /></span>
            <a class="btn_com" @click="openAddVideoDevicePopup()">
              <span class="btn_plus"></span>영상장비등록
            </a>
            <img
              src="/static/seoul/img/excel.png"
              style="width: 30px; cursor: pointer; margin: 0 20px"
              @click="exportCodecList()"
            />
          </div>
        </div>
        <!--//tbw_Top-->

        <!--tbw_tb01-->
        <div class="tbw_tb01">
          <table>
            <caption>
              회의장비리스트
            </caption>
            <thead>
              <tr>
                <th>지역</th>
                <th>회의실 이름</th>
                <th>영상장비명</th>
                <th>단말 IP</th>
                <th>단말링크</th>
                <th>단말상태</th>
                <th>시리얼 넘버</th>
                <!-- <th>코덱 시리얼 넘버</th> -->
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(listItem, index) in filterLimitDevice" :key="index">
                <td>{{ listItem.buildingName }}</td>
                <td>{{ listItem.roomName }}</td>
                <td>{{ listItem.deviceName }}</td>
                <td>
                  <span class="org">{{ listItem.ip }}</span>
                </td>
                <td>
                  <a class="icocom link_ico" @click="clickLink(listItem)"></a>
                </td>
                <td>
                  <span :class="listItem.status === 'a' ? 'red' : ''">{{
                    listItem.status === 'a' ? 'ON' : 'OFF'
                  }}</span>
                </td>
                <td>
                  <span>{{ listItem.sn }}</span>
                </td>
                <!-- <td>
                  <span>{{ listItem.codecSn }}</span>
                </td> -->
                <td>
                  <a
                    class="icocom modi_ico"
                    @click="openEditVideoDevicePopup(listItem)"
                  ></a>
                </td>
                <td>
                  <a
                    class="icocom delete_ico"
                    @click="openDeleteVideoDevicePopup(listItem)"
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>

          <!--total_num-->
          <div class="total_num">
            <p>
              <span>Rows per page :</span
              ><span style="padding-right: 10px">{{ perPage }}</span
              ><span>Total : </span><span>{{ deviceList.length }}</span>
            </p>
          </div>
          <!--total_num-->
        </div>
        <!--//tbw_tb01-->
        <div class="paging">
          <div class="boardnavi">
            <pagination
              :records="deviceList.length"
              v-model="page"
              :per-page="perPage"
            />
          </div>
        </div>
      </div>
      <!--//tbw-->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Util from '@/util';
import VModal from 'vue-js-modal';
import Pagination from 'vue-pagination-2';

Vue.use(VModal);

export default {
  components: {
    Pagination,
  },
  data: () => ({
    page: 1,
    perPage: 10,
    deviceList: [],
    companyList: [],
    buildingList: [],
    filterBuildingList: [],
    roomList: [],
    filterRoomList: [],
    filter: {
      deviceName: '',
      deviceIp: '',
      region: '',
      buildingId: null,
    },
    defaultEditItem: {
      _id: null,
      companyId: null,
      buildingId: null,
      roomId: null,
      ip: null,
      deviceId: null,
      devicePw: null,
      deviceName: null,
      uri: null,
      sn: null,
      codecSn: null,
    },
    editItem: {
      _id: null,
      companyId: null,
      buildingId: null,
      roomId: null,
      ip: null,
      deviceId: null,
      devicePw: null,
      deviceName: null,
      uri: null,
      sn: null,
      codecSn: null,
    },
    deviceEditMode: false,
    delSelectedItem: null,
  }),
  computed: {
    filterLimitDevice() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.deviceList.slice(startPage, limitPage);
    },
  },
  watch: {
    'filter.buildingId': {
      handler(val) {
        this.searchDevice();
      },
    },
  },
  async created() {
    // this.axios.get('http://localhost:8080/server/listTest.json')
    //   .then((response) => {
    //     this.listData = response.data;
    //     console.log(this.listData);
    //   });
  },
  async activated() {
    this.initDeviceList();
    this.initSelectData();
  },
  methods: {
    async openAddVideoDevicePopup() {
      await this.initSelectData();
      this.editItem = Object.assign({}, this.defaultEditItem);
      // companylist의 1번째 항목을 기본 선택
      if (this.companyList.length >= 1) {
        this.editItem.companyId = this.companyList[0].value;
        this.companyChange();
        this.buildingChange();
      }
      this.deviceEditMode = false;
      this.$modal.show('addVideoDevice');
    },
    closeAddVideoDevicePopup() {
      this.$modal.hide('addVideoDevice');
    },
    openDeleteVideoDevicePopup(item) {
      this.delSelectedItem = item;
      this.$modal.show('deleteVideoDevice');
    },
    closeDeleteVideoDevicePopup() {
      this.delSelectedItem = null;
      this.$modal.hide('deleteVideoDevice');
    },
    addVideoDevice() {
      let params = this.editItem;
      console.log(this.editItem)
      if (this.editItem.buildingId === null || this.editItem.roomId === null || this.editItem.ip === null || this.editItem.deviceName === null) {
        alert('지역, 영상장비, IP, Display명은 필수 값입니다.')
        return;
      }
      // params['deviceName'] = this.roomList.find(r => r.value === params.roomId).text;
      // params['siteName'] = this.$store.state.user.siteName;
      /* 영상장비등록 */

      // let duplicateCount = this.deviceList.filter(
      //   (el) =>
      //     el.deviceName === this.editItem.deviceName ||
      //     el.ip === this.editItem.ip
      // ).length;
      // if (duplicateCount > 0) {
      //   alert('중복되는 장비가 있습니다. 장비명, ip를 확인해주세요.');
      //   return false;
      // }

      this.$http
        .post(`/api/v1/devices`, params)
        .then((response) => {
          if (response.data.ret === false && response.data.isDup === true) {
            alert(
              `중복되는 장비가 있습니다. 장비명, ip를 확인해주세요.\n\n 중복 장비: ${response.data.dupInfo.deviceName}(${response.data.dupInfo.ip})`
            );
            return;
          }
          this.initDeviceList();
          this.$modal.hide('addVideoDevice');
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    updateOrganization() {
      this.$http
        .post(`/api/v1/users/updateOrganization`)
        .then((response) => {})
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    async exportCodecList() {
      // let items = [];
      // console.log(`this.deviceList`, this.deviceList);
      // this.deviceList.forEach((device) => {
      //   items.push({
      //     buildingName: device.buildingName,
      //     roomName: device.roomName,
      //     deviceName: device.deviceName,
      //     ip: device.ip,
      //     sn: device.sn,
      //   });
      // });
      // let title = `영상장비 리스트`;
      // let body = {
      //   title: title,
      //   userId: this.$store.state.user.empNum,
      //   items: items,
      //   type: 'manageVideoMeetingRoom',
      // };
      // await this.$http
      //   .post('/api/v1/meetings/ksd/adminListToDocument', body)
      //   .then((response) => {
      //     if (response) {
      //       alert(
      //         `문서중앙화로 전송 완료 - 파일위치 : 스마트회의 관리자/${title}.xlsx`
      //       );
      //     }
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      let title = '영상장비 리스트';
      let columns = [
        { header: '지역', key: 'buildingName', width: 15 },
        { header: '회의실 이름', key: 'roomName', width: 30 },
        { header: '영상장비명', key: 'deviceName', width: 35 },
        { header: '단말 IP', key: 'ip', width: 15 },
        { header: '시리얼 넘버', key: 'sn', width: 30 },
      ];

      let items = [];
      this.deviceList.forEach((device) => {
        items.push({
          buildingName: device.buildingName,
          roomName: device.roomName,
          deviceName: device.deviceName,
          ip: device.ip,
          sn: device.sn,
        });
      });
      console.log(items);

      Util.exportExcel(title, columns, items, true, `${title}.xlsx`);
    },
    initDeviceList() {
      let params = {
        siteName: this.$store.state.user.siteName,
      };
      this.$http
        .get(`/api/v1/devices`, { params: params })
        .then((response) => {
          this.deviceList = response.data;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    clickLink(item) {
      window.open(`https://${item.ip}`);
    },
    async openEditVideoDevicePopup(item) {
      console.log(`openEditVideoDevicePopup`, item);
      await this.initSelectData();
      this.editItem = Object.assign({}, item);
      this.deviceEditMode = true;
      // Company, Building Setting
      this.editItem['companyId'] = this.editItem.companyId;
      this.editItem['buildingId'] = this.editItem.buildingId;
      this.editItem['roomId'] = this.editItem.roomId._id;
      this.companyChange();
      this.buildingChange();
      this.$modal.show('addVideoDevice');
    },

    async initSelectData() {
      let params = { siteName: this.$store.state.user.siteName };
      await this.$http
        .get(`api/v1/company`, { params: params })
        .then((response) => {
          this.companyList = response.data.map((d) => {
            return {
              text: d.name,
              value: d._id,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      await this.$http
        .get(`api/v1/building`, { params: params })
        .then((response) => {
          this.buildingList = response.data.map((d) => {
            return {
              companyId: d.companyId,
              text: d.name,
              value: d._id,
            };
          });
          this.buildingList.unshift({
            text: '전체',
            value: null,
          });
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });

      await this.$http
        .get(`api/v1/rooms`, { params: params })
        .then((response) => {
          this.roomList = response.data.map((d) => {
            return {
              buildingId: d.buildingId,
              text: d.room,
              value: d._id,
            };
          });
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
    companyChange() {
      this.filterBuildingList = this.buildingList.filter(
        (b) => b.companyId === this.editItem.companyId
      );
      // 첫번째 빈값 넣기.
      this.filterBuildingList.unshift({
        companyId: this.editItem.companyId,
        text: '지역을 선택하세요.',
        value: null,
      });
    },
    buildingChange() {
      this.filterRoomList = this.roomList.filter(
        (r) => r.buildingId === this.editItem.buildingId
      );
      // 첫번째 빈값 넣기.
      this.filterRoomList.unshift({
        companyId: this.editItem.buildingId,
        text: '영상회의실을 선택하세요.',
        value: null,
      });
      // 바인딩 돼 있는 값이 filterRoomList 에 없는 값이면, editItem.roomId 값을 null로 초기화.
      if (!this.filterRoomList.find((r) => r.value === this.editItem.roomId)) {
        this.editItem.roomId = null;
      }
    },
    deleteVideoDevice() {
      if (this.delSelectedItem) {
        this.$http
          .post(`/api/v1/devices/deleteDevice/${this.delSelectedItem._id}`)
          .then((response) => {
            this.initDeviceList();
            this.closeDeleteVideoDevicePopup();
          })
          .catch((error) => {
            console.log(error.response.data.error);
          });
      } else {
        Util.snackBarOpen('잘못된 접근 입니다.', 'error');
      }
    },
    searchDevice() {
      let params = {
        buildingId: this.filter.buildingId,
        deviceName: this.filter.deviceName,
        deviceIP: this.filter.deviceIp,
        isAdmin: true,
      };

      this.dateSort = 'desc';
      this.$http
        .get(`/api/v1/devices`, { params: params })
        .then((response) => {
          this.deviceList = response.data;
          this.page = 1;
        })
        .catch((error) => {
          console.log(error.response.data.error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/sections/ManageVideoMeetingRoom.vue